// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { createContext, PropsWithChildren, useMemo, useState } from 'react';
import { QCResult } from '../data/filter/filters-defaults';

export interface LabelMetaDataContextType {
  isValidationDataset: boolean;
  setIsValidationDataset: (isValidationDataset: boolean) => void;
  qcResult: QCResult;
  setQcResult: (qcResult: QCResult) => void;
}

export const LabelMetaDataContext = createContext<LabelMetaDataContextType>({
  isValidationDataset: false,
  setIsValidationDataset: () => {},
  qcResult: QCResult.Undefined,
  setQcResult: () => {},
});

export default function LabelMetaDataProvider({ children }: Readonly<PropsWithChildren>) {
  const [isValidationDataset, setIsValidationDataset] = useState(false);
  const [qcResult, setQcResult] = useState(QCResult.Undefined);

  const value = useMemo(() => {
    return {
      isValidationDataset,
      setIsValidationDataset,
      qcResult,
      setQcResult,
    };
  }, [isValidationDataset, setIsValidationDataset, qcResult, setQcResult]);

  return <LabelMetaDataContext.Provider value={value}>{children}</LabelMetaDataContext.Provider>;
}
